import { Layout } from 'antd';
import * as React from 'react';
import { BasicProps } from 'antd/lib/layout/layout';
import classNames from 'classnames';
import './Content.scss';

const {Content} = Layout;
export default (props: BasicProps & React.RefAttributes<HTMLElement>) => {
  return <Content {...{...props, className: classNames('oms-layout-content', props.className)}} />
};